import { PrimaryButton } from '@systemeio/ui'
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { PaletteIcon } from '@systemeio/ui/icons'

const StoreEditDesignButton = () => {
  const { t } = useLocoTranslation()
  const { onChangeTab } = useStoreQuery()
  return (
    <PrimaryButton onClick={() => onChangeTab(StoreTabEnum.theme)}>
      <PaletteIcon className={'fill-background-secondary'} />
      <span className={'hidden sm:inline'}>{t('dashboard.store.theme.edit_design')}</span>
    </PrimaryButton>
  )
}

export default StoreEditDesignButton
